import(/* webpackMode: "eager" */ "/home/ubuntu/app/stay_booking_web/src/app/(pages)/partner/store/[id]/page.tsx")